import { Component } from "react";
import TitleBar from "../../components/ui/TitleBar";
import HWhiteIc from "../../components/assets/icons/h-white-ic.svg";

import "./style.scss";
import RectButton from "../ui/button/RectButton";

class SubscriptionPlan extends Component {
    render() {
        return (
            <>
                <section className={`subscribe-plan ${this.props.className}`}>
                    <TitleBar title={this.props.title} />
                    <div className="box">
                        <div className="header">
                            <img className="h-logo" src={HWhiteIc} alt="Handwrytten" />
                            { this.props.popular ? <div className="popular"><span>MOST</span><span>POPULAR</span></div> : null }
                        </div>
                        <div className="info">
                            <p className="price">${this.props.price} per month</p>
                            <p className="discount">{this.props.discount}% Off</p>
                            <p className="description">{this.props.description}</p>
                        </div>
                        <RectButton className="select-bt" text="SELECT PLAN" />
                    </div>
                </section>
            </>
        )
    }
}

export default SubscriptionPlan;